"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
class Tokens {
    constructor(storage, prefix) {
        this.shortLiveToken = "";
        this.storage = storage;
        this.prefix = prefix;
    }
    getShortLiveToken() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.shortLiveToken;
        });
    }
    getLongLiveToken() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.storage.getString(`${this.prefix}_LONG_LIVE_TOKEN`, "");
        });
    }
    setShortLiveToken(token) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.shortLiveToken = token;
        });
    }
    setLongLiveToken(token) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.storage.setString(`${this.prefix}_LONG_LIVE_TOKEN`, token);
        });
    }
}
exports.Tokens = Tokens;
//# sourceMappingURL=Tokens.js.map